import { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import { getHighlight } from '../Service/Api';
const News = () => {
  const [data, setData] = useState([]); // State for gallery data
  const [loading, setLoading] = useState(true); // State for loading indicator 

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const newsData1 = await getHighlight(); 
        setData(newsData1);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        // Handle error (e.g., show error message)
      } finally {
        setLoading(false); // Set loading to false after data fetching is complete
      }
    };
    fetchData();
  }, []);
 
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};
  return (
    <>
      <div className="newsbg">
        <div className='title' id="parallelogram">
          <h2>Notice Board <Link to="/News"> </Link></h2>
        </div>
        <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up" onMouseOut={(event) => event.currentTarget.start()}>
        <ul className="newsboxlist">
        {data.length > 0 ? (data.map((item, index) => (  
          <li key={index}>
          <div className="newsbox">
             <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/newgicn.gif" className="img-fluid newsgif" alt="SPCSH"/>  
             <div>
                <div className="newsdesc">
                   {item.new ==='true' && <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/newicn.gif" className="img-fluid" alt="SPCSH"/> }   
                   <h6>{item.title}</h6> 
                   <p>{item.description}</p>
                </div>
                <p><i class="bi bi-calendar-event"></i> {formatDate(item.fromDate)}  </p>
                {item.attachments && item.attachments.length > 0 && (<Link className="learnmorebtn" to={`https://webapi.entab.info/api/image/${item.attachments}`} target="_blank">  Attachments</Link>)} &nbsp;
                {item.url && item.url.length > 0 && (<Link className="learnmorebtn" to={item.url} target="_blank">  Link </Link>)}
             </div>
          </div>
       </li>
    ))
    ) : (
      <li>
      <div className="newsbox">
         <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/newgicn.gif" className="img-fluid newsgif" alt="SPCSH"/>  
         <div>
            <div className="newsdesc"> 
               <h6>Stay Tunned for More Updates!</h6> 
            </div>
            <p><i class="bi bi-calendar-event"></i>  DD.MM  </p>
           <Link className="learnmorebtn" to="/" target="_blank"> Attachments</Link> &nbsp;
           <Link className="learnmorebtn" to="/" target="_blank">  Link </Link> 
         </div>
      </div>
   </li>
    )}  
  </ul>
        </marquee> 
         { /*  <Link to="/NoticeBoard" className="viewall">VIEW ALL <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/viewall.png" alt="SPCSH" className="img-fluid" /></Link> */}
      </div>
    </>
  )
}

export default News
